import { StatusBadge } from '@/components/base';

interface DocumentStatusTagProps {
  status: string;
}

export function DocumentStatusTag({ status }: DocumentStatusTagProps) {
  return <StatusBadge status={status} />;
}
